import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAddProjectMaterialResource,
  useRolesRetrieval,
} from "@planzone/view-models";
import {
  Resource,
  resource,
  ResourceTypes,
  role as roleMock,
} from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { MaterialResourceForm } from "./materialResourceForm";
import styles from "./styles.scss";

function ProjectMaterialResourceAddition({ project, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, addProjectMaterialResource } =
    useAddProjectMaterialResource();
  const { roles } = useRolesRetrieval();
  const [formData, setFormData] = React.useState<Resource>({
    ...resource,
    type: ResourceTypes.MATERIAL,
  });
  const role = roles.find(({ name }) => name === "pr_worker") || {
    ...roleMock,
    uuid: "",
  };

  return (
    <Modal header={t("projectMaterialResourceAddition.title")} close={cancel}>
      <div className={styles.projectMaterialResourceAddition}>
        <form
          className={styles.main}
          onSubmit={(event) => {
            event.preventDefault();
            addProjectMaterialResource({
              project,
              role,
              resource: formData,
            });
          }}
        >
          <MaterialResourceForm formData={formData} edit={setFormData} />
          <div className={styles.buttons}>
            <Button type="cancel" press={cancel}>
              {t("projectMaterialResourceAddition.cancel")}
            </Button>
            <Button
              type="submit"
              status={isRequestPending ? "pending" : "none"}
            >
              {t("projectMaterialResourceAddition.confirm")}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export { ProjectMaterialResourceAddition };
